const state = () => {
  return {
    quiz: {
      questions: [
        {
          question: "are_you_25_years_old_or_younger",
          options: [
            {
              label: "Yes",
              value: "1"
            },
            {
              label: "No",
              value: "0"
            }
          ],
          answer: ""
        },
        {
          question:
            "have_you_had_either_a_new_sex_partner_or_multiple_partners_in_the_last_90_days",
          options: [
            {
              label: "Yes",
              value: "1"
            },
            {
              label: "No",
              value: "0"
            }
          ],
          answer: ""
        },
        {
          question: "right_now_do_you_have_more_than_one_sex_partner",
          options: [
            {
              label: "Yes",
              value: "1"
            },
            {
              label: "No",
              value: "0"
            }
          ],
          answer: ""
        },
        {
          question:
            "have_you_ever_been_told_you_had_a_sexually_transmitted_infection_or_have_you_ever_been_treated_for_a_sexually_transmitted_infection",
          options: [
            {
              label: "Yes",
              value: "1"
            },
            {
              label: "No",
              value: "0"
            }
          ],
          answer: ""
        },
        {
          question: "how_many_sex_partners_have_you_had_in_the_last_90_days",
          options: [
            {
              label: "zero_one",
              value: "0"
            },
            {
              label: "two_four",
              value: "1"
            },
            {
              label: "five_nine",
              value: "2"
            },
            {
              label: "ten_or_more",
              value: "3"
            }
          ],
          answer: ""
        },
        {
          question: "when_you_have_sex_do_you_use_a_condom",
          options: [
            {
              label: "Always",
              value: "0"
            },
            {
              label: "Sometimes",
              value: "3"
            },
            {
              label: "Never",
              value: "3.1"
            }
          ],
          answer: ""
        }
      ],
      risk_status: [
        {
          label: "VeryHighRisk",
          value: "7-10",
          numbers: [7, 8, 9, 10]
        },
        {
          label: "HighRisk",
          value: "4-6",
          numbers: [4, 5, 6]
        },
        {
          label: "IntermediateRisk",
          value: "2-3",
          numbers: [2, 3]
        },
        {
          label: "LowRisk",
          value: "0-1",
          numbers: [0, 1]
        }
      ],
      total: 0,
      result: false,
      answer: [],
      risk_assessment_id: ""
    }
  };
};

export default state;
